import { render, staticRenderFns } from "./InputButtonGroup.vue?vue&type=template&id=61c23243&"
import script from "./InputButtonGroup.vue?vue&type=script&lang=js&"
export * from "./InputButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports